'use strict';

var Joi = require('./index');

var internals = {};
exports.options = Joi.object({
  abortEarly: Joi.boolean(),
  convert: Joi.boolean(),
  allowUnknown: Joi.boolean(),
  skipFunctions: Joi.boolean(),
  stripUnknown: [Joi.boolean(), Joi.object({
    arrays: Joi.boolean(),
    objects: Joi.boolean()
  }).or('arrays', 'objects')],
  language: Joi.object(),
  presence: Joi.string().only('required', 'optional', 'forbidden', 'ignore'),
  context: Joi.object(),
  noDefaults: Joi.boolean(),
  escapeHtml: Joi.boolean()
}).strict();